/**
 * Toggle display of table header.
 *
 * @param {object} $container the table container 
 */
function toggleHeader( $container ) {
	const $headerColumns = $container
		.find( '.m__dashboard-table-header .m__dashboard-table-col' )
		.not( '.m__dashboard-table-col-one' );

	if ( countTotalEntriesChecked( $container ) ) {
		$headerColumns.hide();
	} else {
		$headerColumns.show();
	}
}

/**
 * Toggle display of action button in table header.
 *
 * @param {object} $container the table container  
 * @param {object} $button the action button 
 */
function toggleButtonDisplay( $container, $button ) {
	if ( countTotalEntriesChecked( $container ) ) {
		$button.show();
	} else {
		$button.hide();
	}
}

/**
 * Adds the action button text.
 *
 * @param {object} $container the table container 
 * @param {object} $button the action button  
 */
function addButtonText( $container, $button ) {
	const totalEntries = countTotalEntriesChecked( $container );
	const text = totalEntries > 1 ? 'forms' : 'form'; 
	$button
		.find( '.m__dashboard-table-button-dynamic-text' )
		.html( `${totalEntries} ${text}` );
}

/**
 * Toggle display of action button in table header and adds corresponding text.
 *
 * @param {object} $container the table container 
 */
function toggleButton( $container ) {
	const $button = $container.find( '.m__dashboard-table-button' );
	toggleButtonDisplay( $container, $button );
	addButtonText( $container, $button );
}

/**
 * Triggers Custom Event when the button is clicked.
 *
 * @param {object} $container the table container 
 * @param {string} action the action button action [archive, unarchive]. 
 */
function addButtonEvent( $container, action ) {
	const $button = $container.find( '.m__dashboard-table-button' );
	$button.on( 'click', function onclick() {
		$container.trigger( 
			'onActionButtonClick',
			{
				action,
				data: JSON.stringify( getCheckedEntriesIds( $container ) )
			}
		);
	});
}

/**
 * Get the checked entries Ids.
 *
 * @param {object} $container the table container 
 * @return {array} the checked entry Ids in an array
 */
function getCheckedEntriesIds( $container ) {
	const $checkedEntries = $container
		.find( '.m__dashboard-table-body .input-checkbox-input:checked' );

	const entriesIds = [];
	$.each( $checkedEntries, function mapId() {
		entriesIds.push( $( this ).val() );
	});
	return entriesIds;
}

/**
 * Counts how many entries are checked.
 *
 * @param {object} $container the table container 
 * @return {int} the total number of entries in the table in the actual page
 */
function countTotalEntriesChecked( $container ) {
	return $container
		.find( '.m__dashboard-table-body .input-checkbox-input:checked' )
		.length;
}

/**
 * When header checkbox is checked it selects all the rows checkboxes and shows 
 * the action button.
 *
 * @param {object} $container the table container
 */
function onSelectAllCheckboxes( $container ) {
	$container.on( 'click', '.input-checkbox-select-all', function activate() {
		const $checkboxes = $container.find( '.m__dashboard-table-body .input-checkbox-input' );
		$checkboxes.prop( 'checked', this.checked );
		toggleHeader( $container );
		toggleButton( $container );
	});	
}

/**
 * Unchecks all entries, hides the Action button and shows the header column names. 
 *
 * @param {object} $container the table container
 */
function clearAll( $container ) {
	const $checkboxes = $container.find( '.m__dashboard-table-body .input-checkbox-input' );
	$checkboxes.prop( 'checked', false );
	toggleHeader( $container );
	toggleButton( $container );	
}

/**
 * When a row checkbox is checked it shows the action button.
 *
 * @param {object} $container the table container
 */
function onSelectRowCheckbox( $container ) {
	$container.on( 'click', '.m__dashboard-table-body .input-checkbox-input', function activate() {
		toggleHeader( $container );
		toggleButton( $container );
	});	
}

/**
 * Select entries.
 */
export function selectEntries() {
	const $tableContainer = $( '.m__dashboard-table' );
	if ( !$tableContainer.length ) {
		return;
	}

	const action = $tableContainer.data( 'button-action' );

	onSelectAllCheckboxes( $tableContainer );
	onSelectRowCheckbox( $tableContainer );
	addButtonEvent( $tableContainer, action );

	$tableContainer.on( 'clearSelectedEntries', function onArchive() {
		clearAll( $( this ) );
	});		
}